import React, {
  useState,
  useEffect,
  Fragment,
  useMemo,
  useContext,
} from "react";

import "../Scss/ContactStyles.scss?v=1.1.3";
import {
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControl,
  Autocomplete,
  FormLabel,
  LinearProgress,
  Fade,
  Alert,
} from "@mui/material";
import { Button } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import { NavLink, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material/";

import {
  CommonSubHeader,
  getOptionKey,
  isValidEmail,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import api from "../../api/axios";
import {
  arrayToStatus,
  showDuplicateContactsSwal,
  usarInformacionContacto,
} from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import { Dashboard, Save, TableChart } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { PermissionContext } from "../../Components/Context/Context";
import Unauthorized from "../../Components/Common/Design/Unauthorized";

const DEFAULT_COMPANY = {
  company_name: "Seleccionar",
  id: 0,
};

const DEFAULT_ASSIGN_TO = {
  id: 0,
  name: "Seleccionar",
  surname: "",
};

const DEFAULT_LAWYER = {
  id: 0,
  name: "Seleccionar",
  surname: "",
};

const DEFAULT_PROVINCE = {
  provincia: "Seleccionar",
  id_provincia: 0,
};

const DEFAULT_DOCUMENT_TYPE = {
  id: 0,
  name: "Seleccionar",
};

const DEFAULT_ASSOCIATION = {
  id: 0,
  asoc_name: "Seleccionar",
};

const DEFAULT_CASE_TYPE = {
  id: 0,
  case_type: "Seleccionar",
};

const DEFAULT_STATUS = {
  id: 0,
  nombre: "Pte Llamada",
};

const normalizeTrimmedValue = (value) => String(value ?? "").trim();

const normalizeDigitsValue = (value, maxLength = Infinity) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, maxLength);

const normalizeOptionalSelection = (value, defaultValue) =>
  value && typeof value === "object" ? value : defaultValue;

const buildValidationSwalHtml = (issues = []) => {
  const issueItems = issues
    .map((issue) => `<li><strong>${issue.field}:</strong> ${issue.detail}</li>`)
    .join("");

  return `
    <div class="contact-validation-swal">
      <p class="contact-validation-swal__subtitle">Revise estos campos antes de continuar:</p>
      <ul class="contact-validation-swal__list">${issueItems}</ul>
    </div>
  `;
};

const Crear = () => {
  const navigate = useNavigate();
  const { can } = useContext(PermissionContext);
  const hasPermission = can("contacts", "add");

  const { goPanel, goTable } = useLocationHelpers();
  const Swal = require("sweetalert2");
  const [queryError, setQueryError] = useState(false);
  // OPEN OPTIONS
  const [openOptions, setOpenOptions] = useState({
    assignTo: false,
    lawyer: false,
    companies: false,
    provinces: false,
    asociations: false,
    caseTypes: false,
    status: false,
    document_type: false,
  });

  const [options, setOptions] = useState({
    assignTo: [],
    lawyer: [],
    companies: [],
    provinces: [],
    asociations: [],
    caseTypes: [],
    status: [],
    document_type: [],
  });

  // Loading Options
  const loadingOptions = Object.keys(openOptions).reduce((acc, key) => {
    acc[key] = openOptions[key] && options[key].length === 0;
    return acc;
  }, {});

  // TAKE VALUES
  const [contactData, setContactData] = useState({
    // ================== LEFT ==================
    company: DEFAULT_COMPANY,

    assignTo: DEFAULT_ASSIGN_TO,

    lawyer: DEFAULT_LAWYER,

    name: "",
    surname: "",
    phone: "",
    email: "",
    address: "",
    postalcode: "",

    province: DEFAULT_PROVINCE,

    document_type: DEFAULT_DOCUMENT_TYPE,

    nif: "",

    // ================== RIGHT ==================
    asociation: DEFAULT_ASSOCIATION,

    cases_type: DEFAULT_CASE_TYPE,

    status: DEFAULT_STATUS,

    conditions: "",
    title: "",

    // ================== EXTRAS / BACKEND ==================
    observations: "",
    marketing: 0,
    date_in: "",
  });

  const [marketingToShow, setMarketingToShow] = useState("");
  const [marketingToSend, setMarketingToSend] = useState("");
  // ERRORES
  // LABEL CHANGE
  const [valCaseTypeForm, setValCaseTypeForm] = useState("");

  const [flag, setFlag] = useState(false);
  const [userLogged, setUserLogged] = useState(0);
  const [changeOptionsFlag, setChangeOptionsFlag] = useState(false);
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);

  // GET DATA LIST
  const getDataList = async () => {
    setFlag(false);
    const url = `${process.env.REACT_APP_API_URL}/contacts/create`;

    try {
      const response = await api.post(url);
      const data = response.data;
      // console.log(data);

      // Verificar si el token es válido
      const {
        cases_type,
        companies,
        associations,
        lawyers,
        provinces,
        document_types,
        user_logged,
      } = data;

      setUserLogged(user_logged);

      // Actualizar los estados con las listas preparadas
      setOptions({
        assignTo: [],
        lawyer: [],
        companies: [DEFAULT_COMPANY, ...companies],
        provinces: [DEFAULT_PROVINCE, ...provinces],
        status: arrayToStatus,
        document_type: [DEFAULT_DOCUMENT_TYPE, ...document_types],
        asociations: [DEFAULT_ASSOCIATION, ...associations],
        caseTypes: [],
      });

      setContactData((prevData) => ({
        ...prevData,
        company:
          companies.find((company) => company.id === user_logged.company_id) ||
          DEFAULT_COMPANY,
        status: DEFAULT_STATUS,
      }));

      filterDataByCompany(user_logged.company_id);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setFlag(true);
    }
  };

  const handleContactsFormInformation = async () => {
    const trimmedName = normalizeTrimmedValue(contactData?.name);
    const trimmedSurname = normalizeTrimmedValue(contactData?.surname);
    const trimmedPhone = normalizeDigitsValue(contactData?.phone, 15);
    const trimmedEmail = normalizeTrimmedValue(contactData?.email);
    const trimmedPostalCode = String(contactData?.postalcode ?? "")
      .replace(/[^A-Za-z0-9]/g, "")
      .toUpperCase()
      .slice(0, 10);
    const trimmedNif = normalizeTrimmedValue(contactData?.nif).toUpperCase();
    const trimmedAddress = normalizeTrimmedValue(contactData?.address);
    const trimmedConditions = normalizeTrimmedValue(contactData?.conditions);
    const trimmedTitle = normalizeTrimmedValue(contactData?.title);
    const trimmedObservations = normalizeTrimmedValue(
      contactData?.observations,
    );

    setContactData((prevData) => ({
      ...prevData,
      name: trimmedName,
      surname: trimmedSurname,
      phone: trimmedPhone,
      email: trimmedEmail,
      postalcode: trimmedPostalCode,
      nif: trimmedNif,
      address: trimmedAddress,
      conditions: trimmedConditions,
      title: trimmedTitle,
      observations: trimmedObservations,
    }));

    const validationIssues = [];

    if (!contactData?.company?.id) {
      validationIssues.push({
        field: "Empresa",
        detail: "Debe seleccionar una empresa.",
      });
    }

    if (!contactData?.assignTo?.id) {
      validationIssues.push({
        field: "Asignar a",
        detail: "Seleccione el usuario responsable.",
      });
    }

    if (!trimmedName) {
      validationIssues.push({
        field: "Nombre",
        detail: "El nombre es obligatorio.",
      });
    }

    if (!trimmedSurname) {
      validationIssues.push({
        field: "Apellido",
        detail: "El apellido es obligatorio.",
      });
    }

    if (!trimmedPhone) {
      validationIssues.push({
        field: "Teléfono",
        detail: "El teléfono es obligatorio.",
      });
    }

    if (!contactData?.cases_type?.id) {
      validationIssues.push({
        field: "Tipo de caso",
        detail: "Seleccione un tipo de caso.",
      });
    }

    if (trimmedEmail && !isValidEmail(trimmedEmail)) {
      validationIssues.push({
        field: "Email",
        detail: "El formato del correo no es valido.",
      });
    }

    if (trimmedPostalCode && trimmedPostalCode.length > 10) {
      validationIssues.push({
        field: "Codigo postal",
        detail: "No puede superar los 10 caracteres.",
      });
    }

    if (trimmedPhone && trimmedPhone.length < 9) {
      validationIssues.push({
        field: "Telefono",
        detail: "Debe tener al menos 9 digitos.",
      });
    }

    if (trimmedNif && !contactData?.document_type?.id) {
      validationIssues.push({
        field: "Tipo de documento",
        detail: "Seleccione el tipo si informa un documento.",
      });
    }

    if (contactData?.document_type?.id && !trimmedNif) {
      validationIssues.push({
        field: "Documento de identidad",
        detail: "Complete el numero de documento.",
      });
    }

    if (validationIssues.length > 0) {
      await Swal.fire({
        title: "Campos obligatorios pendientes",
        icon: "warning",
        html: buildValidationSwalHtml(validationIssues),
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Entendido",
        customClass: {
          popup: "contact-validation-swal__popup",
          title: "contact-validation-swal__title",
          htmlContainer: "contact-validation-swal__container",
          confirmButton: "contact-validation-swal__button",
        },
      });
      return;
    }

    const baseUrl = `${process.env.REACT_APP_API_URL}/contacts/search`;

    const queryParams = {
      email: trimmedEmail,
      document: trimmedNif,
      phone: trimmedPhone,
      company_id: contactData?.company?.id || null,
    };

    console.log(contactData);

    let continuarFlujo = true;

    /* =====================================================
     * BUSCAR DUPLICADOS
     * ===================================================== */
    try {
      Swal.fire({
        title: "Buscando coincidencias...",
        text: "Por favor espere un momento",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const { data } = await api.post(baseUrl, queryParams);

      console.log(data);
      Swal.close();

      if (data?.contacts?.length) {
        const contactosUnicos = Array.from(
          new Map(data.contacts.map((c) => [c.id, c])).values(),
        );

        const contactosPreparados = contactosUnicos.map((contacto) => {
          const coincidencias = [];

          if (contacto.email === contactData?.email)
            coincidencias.push("Correo");

          if (contacto.phone === contactData?.phone)
            coincidencias.push("Teléfono");

          if (contacto.nif === contactData?.nif)
            coincidencias.push("Documento");

          return { ...contacto, coincidencias };
        });

        const result = await showDuplicateContactsSwal({
          incomingUser: contactosPreparados,
          flags: data.flag,
          origin: window.location.origin,
          incomingSite: "contactos",
          onUseContact: (contactoSeleccionado) => {
            usarInformacionContacto(
              contactoSeleccionado,
              "contacto",
              null,
              setContactData,
            );
          },
        });

        if (!result.isConfirmed) return;
      }
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al buscar los contactos.",
        icon: "error",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    /* =====================================================
     * CREAR CONTACTO
     * ===================================================== */
    const formattedData = {
      email: trimmedEmail,
      name: trimmedName,
      surname: trimmedSurname,
      postalcode: trimmedPostalCode,
      nif: trimmedNif,
      phone: trimmedPhone,
      province:
        contactData?.province?.provincia !== "Seleccionar"
          ? contactData?.province?.provincia || ""
          : "",
      condiciones: trimmedConditions.replace(/\n/g, "<br />") || "",
      marketing: marketingToSend || 0,
      address: trimmedAddress,
      document_type: contactData?.document_type?.id || 0,
      asociation: contactData?.asociation?.id || 0,
      case_type: contactData?.cases_type?.id || 0,
      status: contactData?.status?.id || 0,
      lawyer: contactData?.lawyer?.id || 0,
      user_id: contactData?.assignTo?.id || 0,
      company_id: contactData?.company?.id || 0,
    };

    const formData = new FormData();
    Object.entries(formattedData).forEach(([k, v]) => formData.append(k, v));

    const confirm = await Swal.fire({
      title: "¿Desea guardar los cambios?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Guardar",
      denyButtonText: "Volver",
      confirmButtonColor: "#1ab394",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
      title: "Guardando contacto...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/store`,
        formData,
      );

      Swal.close();

      if (response.data?.error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          html: response.data.error.errorInfo[2],
        });
        return;
      }

      const contactIdCreated = response.data?.contact_create?.id;
      if (!contactIdCreated) return;

      /* =====================================================
       * HISTÓRICO (SE MANTIENE)
       * ===================================================== */
      const historicalData = {
        // notas:
        //   valCaseTypeForm !== ""
        //     ? valCaseTypeForm.replace(/\n/g, "<br />")
        //     : "El contacto se ha registrado de forma correcta",
        title: contactData?.title || "REGISTRO DE CONTACTO",
        case_type: contactData?.cases_type?.id || 0,
        status: contactData?.status?.id || 0,
        lawyer: contactData?.lawyer?.id || 0,
        user_id: contactData?.assignTo?.id || 0,
        created_by: userLogged.id || 0,
        company_id: contactData?.company?.id || 0,
        document: trimmedNif,
        contact_id: contactIdCreated,
        notas: trimmedObservations.replace(/\n/g, "<br />") || "",
      };

      console.log(historicalData);

      const formDataHistorical = new FormData();
      Object.entries(historicalData).forEach(([k, v]) =>
        formDataHistorical.append(k, v),
      );

      const responseX = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/create_historical`,
        formDataHistorical,
      );

      console.log(responseX);

      await Swal.fire({
        icon: "success",
        title: "¡Guardado correctamente!",
        timer: 1800,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        navigate(`/contactos/ver?id=${contactIdCreated}`);
      });
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "No se pudo guardar el contacto.",
      });
    }
  };

  // Función para actualizar valores específicos del contacto
  const updateContactData = (key, value) => {
    setContactData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // SET VARIABLES
  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataList();
  }, []);

  //////////////////// LOW BUTTONS ///////////////////////
  // const caseTypeFunctionChange = (case_id) => {
  //   // console.log("valor1 :" + case_id);
  //   var texto_incapacidad =
  //     "Fecha nacimiento(edad):\nEstado Civil:\nHijos a su cargo:\nSituación Laboral (Funciones que desempeña en su caso):\n¿Alguna Invalidez otorgada o en trámite?:\n¿Cobra dependencia o alguna otra pensión? (En caso afirmativo indicar el tipo de pensión):\n¿Ha presentado recientemente alguna solicitud?\n¿Tiene resolución?\n¿En qué fecha le fue comunicada?";
  //   if (case_id === 9 || case_id === 6 || case_id === 10 || case_id === 11) {
  //     // console.log("valor2 :" + case_id);
  //     setValCaseTypeForm(texto_incapacidad);
  //   }

  //   // $("#notas").html(texto_incapacidad);
  //   // } else {
  //   //   $("#notas").text("");
  // };

  const handleChangeCheckbox = (event) => {
    // console.log(event.target);
    if (event.target.checked == true) {
      setMarketingToSend(1);
      setMarketingToShow(true);
    } else {
      setMarketingToSend(0);
      setMarketingToShow(false);
    }
  };

  const fieldsConfigLeft = useMemo(() => {
    return [
      {
        key: "companyId",
        type: "autocomplete",
        value: contactData?.company || null,
        label: "Empresa",
        className: "companyId",
        open: openOptions.companies,
        options: options.companies,
        loading: loadingOptions.companies,
        onChange: async (event, value) => {
          const normalizedCompany = normalizeOptionalSelection(
            value
              ? {
                  id: value.id,
                  company_name: value.company_name,
                }
              : null,
            DEFAULT_COMPANY,
          );

          updateContactData("company", normalizedCompany);

          await filterDataByCompany(normalizedCompany.id || 0, true);
        },
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => `${option.company_name}`,
      },
      {
        key: "assignTo",
        type: "autocomplete",
        value: contactData?.assignTo || null,
        disabled: contactData?.company?.id == 0 ? true : false,
        label: "Asignar a",
        className: "assignToId",
        open: openOptions.assignTo,
        options: options.assignTo,
        loading: loadingOptions.assignTo,
        onChange: (event, value) =>
          updateContactData(
            "assignTo",
            normalizeOptionalSelection(value, DEFAULT_ASSIGN_TO),
          ),
        isOptionEqualToValue: (option, value) => option.id === value?.id,
        getOptionLabel: (option) => `${option.name} ${option.surname}`,
      },
      {
        key: "lawyer",
        type: "autocomplete",
        value: contactData?.lawyer || null,
        disabled: contactData?.company?.id == 0 ? true : false,
        label: "Abogado",
        className: "lawyerId",
        open: openOptions.lawyer,
        options: options.lawyer,
        loading: loadingOptions.lawyer,
        onChange: (event, value) =>
          updateContactData(
            "lawyer",
            normalizeOptionalSelection(value, DEFAULT_LAWYER),
          ),
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => `${option.name} ${option.surname}`,
      },
      {
        type: "text",
        label: "Nombre",
        value: contactData?.name || "",
        id: "name",
        column: 6,
        onChange: (event) => updateContactData("name", event.target.value),
      },
      {
        type: "text",
        label: "Apellido",
        column: 6,
        value: contactData?.surname || "",
        id: "surname",
        onChange: (event, value) =>
          updateContactData(
            "surname",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Teléfono",
        column: 6,
        value: contactData?.phone || "",
        id: "phone",
        inputType: "text",
        onChange: (event, value) =>
          updateContactData(
            "phone",
            normalizeDigitsValue(event.target.value, 15),
          ),
        inputProps: {
          maxLength: 15,
          inputMode: "numeric",
        },
      },
      {
        type: "text",
        label: "Email",
        column: 6,
        value: contactData?.email || "",
        id: "email",
        onChange: (event, value) =>
          updateContactData(
            "email",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Dirección",
        value: contactData?.address || "",
        id: "address",
        column: 8,
        onChange: (event, value) =>
          updateContactData(
            "address",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Código postal",
        column: 4,
        value: contactData?.postalcode != null ? contactData?.postalcode : "",
        id: "postalcode",
        onChange: (event) =>
          updateContactData(
            "postalcode",
            String(event.target.value ?? "")
              .replace(/[^A-Za-z0-9]/g, "")
              .toUpperCase()
              .slice(0, 10),
          ),
        inputProps: {
          maxLength: 10,
        },
      },
      {
        key: "province",
        value: contactData?.province || null, // Usar una cadena vacía si es null o undefined
        type: "autocomplete",
        label: "Provincia",
        className: "selectWithInput",
        open: openOptions.provinces,
        options: options.provinces,
        loading: loadingOptions.provinces,
        onChange: (event, value) =>
          updateContactData(
            "province",
            normalizeOptionalSelection(value, DEFAULT_PROVINCE),
          ),
        isOptionEqualToValue: (option, value) =>
          option.provincia === value?.provincia,
        getOptionLabel: (option) => option.provincia,
      },
      {
        key: "document_type",
        value: contactData?.document_type || null, // Usar una cadena vacía si es null o undefined
        type: "autocomplete",
        column: 5,
        label: "Tipo de documento",
        className: "selectWithInput",
        open: openOptions.document_type,
        options: options.document_type,
        loading: loadingOptions.document_type,
        onChange: (event, value) =>
          updateContactData(
            "document_type",
            normalizeOptionalSelection(value, DEFAULT_DOCUMENT_TYPE),
          ),
        isOptionEqualToValue: (option, value) => option.name === value?.name,
        getOptionLabel: (option) => option.name,
      },
      {
        type: "text",
        column: 7,
        label: "Documento de identidad",
        value: contactData?.nif || "", // Usar una cadena vacía si es null o undefined
        id: "nif",
        onChange: (event, value) =>
          updateContactData("nif", event.target.value?.toUpperCase() || ""),
      },
    ];
  }, [
    changeOptionsFlag,
    contactData, // Si cambian las opciones, también se vuelve a calcular.
  ]);

  const fieldsConfigRight = useMemo(() => {
    const commonFields = [
      {
        key: "asociation",
        value: contactData?.asociation,
        // disabled: contactData?.company?.id == 0 ? true : false,
        type: "autocomplete",
        label: "Asociaciones",
        className: "asociationsId",
        open: openOptions.asociations,
        options: options.asociations,
        loading: loadingOptions.asociations,
        onChange: (event, value) => {
          updateContactData(
            "asociation",
            normalizeOptionalSelection(value, DEFAULT_ASSOCIATION),
          );
        },
        isOptionEqualToValue: (option, value) =>
          option.asoc_name === value?.asoc_name,
        getOptionLabel: (option) => option.asoc_name,
      },
      {
        key: "caseTypeName",
        type: "autocomplete",
        value: contactData?.cases_type || null,
        disabled: contactData?.company?.id == 0 ? true : false,
        label: "Tipo de caso",
        className: "caseTypeId",
        open: openOptions.caseTypes,
        options: options.caseTypes,
        loading: loadingOptions.caseTypes,
        onChange: (event, value) => {
          updateContactData(
            "cases_type",
            normalizeOptionalSelection(value, DEFAULT_CASE_TYPE),
          );
          if (value) {
            // caseTypeFunctionChange(value.id);
            setContactData((prev) => ({
              ...prev,
              observations: value?.case_form || "",
            }));
          }
        },
        isOptionEqualToValue: (option, value) =>
          option.case_type === value?.case_type,
        getOptionLabel: (option) => option.case_type,
      },
      {
        key: "status",
        value: contactData?.status || { nombre: "Pte Llamada", id: 0 },
        type: "autocomplete",
        label: "Estado",
        className: "status",
        open: openOptions.status,
        options: options.status,
        loading: loadingOptions.status,
        onChange: (event, value) => {
          updateContactData(
            "status",
            normalizeOptionalSelection(value, DEFAULT_STATUS),
          );
        },
        isOptionEqualToValue: (option, value) =>
          option.nombre === value?.nombre,
        getOptionLabel: (option) => option.nombre,
      },
      {
        type: "text",
        label: "Condiciones especiales",
        column: 6,
        value: contactData?.conditions,
        onChange: (event) =>
          updateContactData("conditions", event.target.value),
      },
      {
        type: "text",
        label: "Titulo observación",
        column: 6,
        value: contactData?.title,
        onChange: (event) => updateContactData("title", event.target.value),
      },
      {
        type: "textarea",
        id: "ObservacionesId",
        label: "Observaciones",
        rows: 18,
        value: contactData?.observations,
        onChange: (event) =>
          updateContactData("observations", event.target.value),
      },
    ];

    return commonFields;
  }, [changeOptionsFlag, contactData, valCaseTypeForm]);

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = async (
    company_id,
    flagFromCompanyInput = false,
  ) => {
    const resetCompanyDependentData = () => {
      setOptions((prevData) => ({
        ...prevData,
        assignTo: [DEFAULT_ASSIGN_TO],
        lawyer: [DEFAULT_LAWYER],
        asociations: [DEFAULT_ASSOCIATION],
        caseTypes: [DEFAULT_CASE_TYPE],
      }));

      const defaultValues = {
        assignTo: DEFAULT_ASSIGN_TO,
        lawyer: DEFAULT_LAWYER,
        asociation: DEFAULT_ASSOCIATION,
        cases_type: DEFAULT_CASE_TYPE,
      };

      Object.entries(defaultValues).forEach(([key, value]) =>
        updateContactData(key, value),
      );
    };

    if (!company_id) {
      resetCompanyDependentData();
      return;
    }

    const openedLoadingFromCompanyChange = flagFromCompanyInput === true;

    try {
      setIsCompanyLoading(true);

      if (openedLoadingFromCompanyChange) {
        Swal.fire({
          title: "Actualizando empresa...",
          text: "Cargando abogados, asignaciones y tipos de caso.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => Swal.showLoading(),
        });
      }

      const queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;
      const { data } = await api.post(queryUrl, { company: company_id });

      if (!data) {
        throw new Error("No se recibieron datos dependientes de la empresa.");
      }

      const { cases_types = [], lawyers = [], associations = [] } = data;

      setOptions((prevData) => ({
        ...prevData,
        assignTo: [DEFAULT_ASSIGN_TO, ...lawyers],
        lawyer: [DEFAULT_LAWYER, ...lawyers],
        asociations: [DEFAULT_ASSOCIATION, ...associations],
        caseTypes: [DEFAULT_CASE_TYPE, ...cases_types],
      }));

      if (flagFromCompanyInput == true) {
        const defaultValues = {
          assignTo: DEFAULT_ASSIGN_TO,
          lawyer: DEFAULT_LAWYER,
          asociation: DEFAULT_ASSOCIATION,
          cases_type: DEFAULT_CASE_TYPE,
        };

        Object.entries(defaultValues).forEach(([key, value]) =>
          updateContactData(key, value),
        );
      }

      setChangeOptionsFlag((prevFlag) => !prevFlag);
    } catch (error) {
      console.log(error);
      resetCompanyDependentData();

      if (openedLoadingFromCompanyChange) {
        await Swal.fire({
          title: "Error",
          text: "No se pudieron cargar los datos dependientes de la empresa seleccionada.",
          icon: "error",
          confirmButtonColor: "#1ab394",
        });
      }
    } finally {
      setIsCompanyLoading(false);

      if (openedLoadingFromCompanyChange) {
        Swal.close();
      }
    }
  };

  //////////////////// SPECIAL BUTTOM ///////////////////////
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Contactos" subTitle="Crear" />

      {!hasPermission && <Unauthorized />}

      {hasPermission && (
        <Fade timeout={600} in={flag}>
          <Box
            component="form"
            sx={{ margin: "auto", "& > :not(style)": {} }}
            noValidate
            autoComplete="off"
            className="formMainContainer">
            <Alert sx={{ marginBottom: "10px" }} color="info" severity="info">
              <b>NOTA IMPORTANTE:</b>{" "}
              <span>
                Para buscar contactos duplicados, basta con ingresar la empresa
                + el correo, la identificación o el teléfono y presionar
                Guardar.
              </span>
            </Alert>
            <Grid
              container
              spacing={2}
              textAlign="center"
              className="fontSize"
              alignItems="flex-start"
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}>
              {/* ================= LEFT ================= */}
              <Grid
                container
                item
                spacing={1}
                p="8px"
                sx={{
                  flexBasis: { xs: "100%", sm: "50%" },
                  maxWidth: { xs: "100%", sm: "50%" },
                  height: "fit-content",
                  alignContent: "flex-start",
                  minWidth: 0,
                }}>
                {fieldsConfigLeft.map((field, index) => (
                  <Grid
                    item
                    xs={field.column ?? 12}
                    key={field.key || index}
                    sx={{
                      height: "fit-content",
                    }}>
                    {field.type === "text" ? (
                      <TextField
                        value={field.value}
                        id={field.id}
                        label={field.label}
                        disabled={field.disabled}
                        onChange={field.onChange}
                        type={field.inputType ?? "text"}
                        size="small"
                        variant="outlined"
                        className="inputFormCreate"
                        inputProps={{
                          ...field.inputProps,
                          onInput: (event) => {
                            if (
                              field.id === "postalcode" &&
                              event.target.value.length > 5
                            ) {
                              event.target.value = event.target.value.slice(
                                0,
                                5,
                              );
                            }
                          },
                        }}
                      />
                    ) : field.type === "autocomplete" ? (
                      <FormControl
                        className="inputFormCreate fontSize"
                        fullWidth>
                        <Autocomplete
                          value={field.value || null}
                          disabled={field.disabled}
                          className={field.className}
                          size="small"
                          options={field.options || []}
                          onChange={field.onChange}
                          isOptionEqualToValue={field.isOptionEqualToValue}
                          getOptionLabel={field.getOptionLabel}
                          renderOption={(props, option) => (
                            <li {...props} key={getOptionKey(option)}>
                              {field.getOptionLabel(option)}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {field.loading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    ) : null}
                  </Grid>
                ))}
              </Grid>

              {/* ================= RIGHT ================= */}
              <Grid
                container
                item
                spacing={1}
                p="8px"
                sx={{
                  flexBasis: { xs: "100%", sm: "50%" },
                  maxWidth: { xs: "100%", sm: "50%" },
                  height: "fit-content",
                  alignContent: "flex-start",
                  minWidth: 0,
                }}>
                {fieldsConfigRight.map((field, index) => (
                  <Grid
                    item
                    xs={field.column ?? 12}
                    sx={{
                      height: "fit-content",
                    }}
                    key={field.key || field.id || index}>
                    {field.type === "autocomplete" ? (
                      <FormControl
                        className="inputFormCreate fontSize"
                        fullWidth>
                        <Autocomplete
                          value={field.value || null}
                          disabled={field.disabled}
                          className={field.className}
                          size="small"
                          options={field.options || []}
                          onChange={field.onChange}
                          isOptionEqualToValue={field.isOptionEqualToValue}
                          getOptionLabel={field.getOptionLabel}
                          renderOption={(props, option) => (
                            <li {...props} key={getOptionKey(option)}>
                              {field.getOptionLabel(option)}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {field.loading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    ) : field.type === "textarea" ? (
                      <FormControl fullWidth>
                        <FormLabel sx={{ textAlign: "left" }}>
                          {field.label}
                        </FormLabel>
                        <textarea
                          rows={field.rows}
                          value={field.value || ""}
                          id="observationsId"
                          onChange={field.onChange}
                          style={{
                            resize: "none",
                            padding: "6px 13px",
                            fontSize: "14px",
                            border: "1px solid rgba(128,128,128,0.35)",
                            borderRadius: "10px",
                            height: "175px",
                          }}
                        />
                      </FormControl>
                    ) : field.type === "text" ? (
                      <TextField
                        id={field.id}
                        label={field.label}
                        value={field.value || ""}
                        onChange={field.onChange}
                        size="small"
                        variant="outlined"
                        className="inputFormCreate fontSize"
                      />
                    ) : null}
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* MARKETING  */}
            <Grid
              sx={{
                boxShadow: "0px 1px 4px 0px gray",
                width: "100%",
              }}
              className="alignItemsAndLeft"
              item
              xs={12}
              p={1}>
              <Checkbox
                checked={
                  marketingToShow == false || marketingToSend == 0
                    ? false
                    : true
                }
                onClick={handleChangeCheckbox}
                inputProps={{ "aria-label": "controlled" }}
                color="success"
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                    width: 28,
                    height: 28,
                  },
                }}
              />
              <span
                style={{
                  fontWeight: "700",
                  textAlign: "left",
                  color: "#676a6c",
                }}>
                Acepto el uso de mi correo electrónico para el envío de
                comunicaciones con fines informativos y comerciales.
              </span>
            </Grid>
            <Grid container item xs={12}>
              <ButtonGroup
                fullWidth
                sx={{
                  mt: 2,
                }}>
                <Button
                  onClick={handleContactsFormInformation}
                  variant="contained"
                  disabled={isCompanyLoading}
                  startIcon={<Save />}
                  color="success">
                  Guardar
                </Button>

                <Button
                  component={Link}
                  to="/panel"
                  startIcon={<Dashboard />}
                  variant="outlined">
                  Panel
                </Button>

                <Button
                  component={Link}
                  to="/contactos"
                  startIcon={<TableChart />}
                  variant="outlined"
                  color="error">
                  Tabla contactos
                </Button>
              </ButtonGroup>
            </Grid>
          </Box>
        </Fade>
      )}
    </div>
  );
};

export default Crear;
